import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, MapPin, ShieldCheck } from "lucide-react";
import { waLink, WA_DISPLAY } from "../lib/site";

const FOOTER_TEXTS = ["© 2026 PT. Fasnet Sky Fiber", "Internet Untuk Semua"];

export default function Footer() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % FOOTER_TEXTS.length), 3000);
    return () => clearInterval(t);
  }, []);
  return (
    <footer data-testid="footer" className="relative overflow-hidden border-t border-white/10 bg-[#0A1124]/40">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 pb-10 pt-8 sm:pt-10 md:grid-cols-3 lg:px-8">
        <div>
          <img src="/images/logo.png" alt="Fasnet Fiber" className="h-12 w-auto" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
            Perumahan Bumi Ayu Lestari Blok B No. 15, Kec. Sungai Raya, Kabupaten Kubu Raya
          </p>
          <p className="mt-4 flex items-center gap-2 text-xs text-slate-500">
            <MapPin className="h-3.5 w-3.5 text-[#FF6B35]" /> Kalimantan Barat, Indonesia
          </p>
        </div>

        <div data-testid="footer-legal">
          <h4 className="flex items-center gap-2 font-display text-sm font-bold uppercase tracking-wider text-white">
            <ShieldCheck className="h-4 w-4 text-emerald-400" /> Legalitas Resmi
          </h4>
          <ul className="mt-5 space-y-3 font-mono text-xs text-slate-400">
            <li><span className="text-slate-500">Badan Usaha:</span><br /><span className="text-slate-200">PT. Fasnet Sky Fiber</span></li>
            <li><span className="text-slate-500">SKLO Kemkomdigi:</span> <span className="text-cyan-300">372/TEL.04.02/2024</span></li>
            <li><span className="text-slate-500">AS Number:</span> <span className="text-cyan-300">AS152793</span></li>
            <li><span className="text-slate-500">NIB:</span> <span className="text-slate-200">0105240016275</span></li>
            <li><span className="text-slate-500">NPWP:</span> <span className="text-slate-200">20.021.354.4-704.000</span></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">Hubungi Kami</h4>
          <a
            data-testid="footer-whatsapp-link"
            href={waLink("Halo CS Fasnet Fiber, saya ingin tanya info pemasangan internet baru")}
            target="_blank"
            rel="noreferrer"
            className="mt-5 inline-flex items-center gap-2 rounded-full bg-emerald-500 px-5 py-2.5 text-sm font-bold text-white transition-colors duration-200 hover:bg-emerald-400"
          >
            <MessageCircle className="h-4 w-4" /> {WA_DISPLAY}
          </a>
          <div className="mt-6">
            <img
              src="/images/apjii.png"
              alt="APJII — Asosiasi Penyelenggara Jasa Internet Indonesia"
              data-testid="footer-apjii-logo"
              className="h-12 w-auto opacity-60 grayscale brightness-[2.4] transition-opacity duration-300 hover:opacity-100 sm:h-14"
            />
          </div>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <p className="mx-auto max-w-7xl px-5 py-5 text-center text-xs text-slate-500 lg:px-8">
          <AnimatePresence mode="wait">
            <motion.span
              key={idx}
              data-testid="footer-rotating-text"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.35 }}
              className="inline-block"
            >
              {FOOTER_TEXTS[idx]}
            </motion.span>
          </AnimatePresence>
        </p>
      </div>
    </footer>
  );
}
